import React from 'react'
import "./Button.css"

const Button = () => {
  return (
    <>
        <button className="btn">Read More</button>
    </>
  )
}

export default Button